window.Yext = window.Yext || {};
import 'babel-polyfill';
import 'script-loader!node_modules/jquery/dist/jquery.min.js';


require('bootstrap-sass/assets/javascripts/bootstrap/collapse.js');
require('bootstrap-sass/assets/javascripts/bootstrap/transition.js');

import { Global } from 'js/common/global.js';
import { OnReady } from 'js/components/Util/Browser.js';
import { Description } from 'js/components/Description/index.js';
import { GoogleAnalytics } from 'js/components/GoogleAnalytics/index.js';
import { Maps } from 'js/components/Maps/index.js';
import { ClientMap } from 'js/common/modules/ClientMap.js';
import { Hours } from 'js/location/modules/CustomHours.js';
import { Visits } from 'js/location/modules/Visits.js';
import { FAQ } from 'js/components/Cobalt/FAQ.js';
import { JobsCarousel } from './location/modules/JobsCarousel';
import Collapser from 'js/location/modules/Collapser.js';

Yext.Maps = Maps;
Yext.Maps.ClientMap = ClientMap;

Global.init();
GoogleAnalytics.enableAutotracking('yext');

OnReady(() => {
  Maps.loadAndRun();
  Hours.loadAndRun();
  Visits.loadAndRun();
  new JobsCarousel();
  FAQ.init();
  Collapser.run();


  $(document).on('show.bs.collapse', '.Collapser-nav--mobile > .Collapser-detailsWrapper', function(){
    $('.Collapser-overlay').css('display', 'flex');
  });

  $(document).on('hide.bs.collapse', '.Collapser-nav--mobile > .Collapser-detailsWrapper', function(){
    $('.Collapser-overlay').css('display', 'none');
  });

  $('.Collapser-overlay').click(function() {
    $('.Collapser-nav--mobile > .Collapser-detailsWrapper').collapse('hide');
  });
});
